import React, { useEffect, useContext } from "react";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";

import ProfileService from "../../../services/User/ProfileService";
import LoadingContext from "../../../store/loading-context";
import HttpError from "../../../utill/HttpError";

const SsoLogin = () => {
  const loadingCtx = useContext(LoadingContext);
  const location = useLocation();

  // Helper: parse query params
  const getQueryParams = () => {
    return new URLSearchParams(location.search);
  };

  useEffect(() => {
    const params = getQueryParams();
    const accessToken = params.get("access_token"); // ?access_token=xyz
    const redirectUrl = params.get("redirect") || "/user/dashboard"; // default dashboard

    if (accessToken) {
      fetchProfile(accessToken, redirectUrl);
    } else {
      Swal.fire("Oops!", "Missing access token", "error");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchProfile = async (accessToken, redirectUrl) => {
    loadingCtx.startLoading();

    try {
      const data = await ProfileService.fetch(accessToken);

      if (!data) {
        throw new Error("Request Failed!");
      }

      const { status, message } = data;

      if (status === "SUCCESS") {
        const {
          name,
          user_id,
          user_type,
          mobile,
          email,
          fpay_outlet_onboarded,
        } = data.data;

        localStorage.setItem("timestamp", new Date().getTime());
        localStorage.setItem("access_token", accessToken);
        localStorage.setItem(
          "user",
          JSON.stringify({
            name,
            user_type,
            user_id,
            mobile,
            email,
          })
        );

        localStorage.setItem("is_outlet", fpay_outlet_onboarded === "YES");

        // Redirect to given path
        window.location.href = redirectUrl;
        //  Swal.fire("Success!", message, "success");
      } else {
        Swal.fire("Oops!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Oops!", errMsg, "error");
    }

    loadingCtx.stopLoading();
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column",
        textAlign: "center",
      }}
    >
      <div className="spinner-border text-primary mb-3" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <h5>Please wait...</h5>
      <p>Redirecting to your account</p>
    </div>
  );
};

export default SsoLogin;
